// extracted by mini-css-extract-plugin
export default {"container":"F1-z","list":"G1-z"};